/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatientFTTicketCreateSchema } from '../models/PatientFTTicketCreateSchema';
import type { PatientFTTicketDetailSchema } from '../models/PatientFTTicketDetailSchema';
import type { PatientFTTicketListSchema } from '../models/PatientFTTicketListSchema';
import type { PatientFTTicketUpdateSchema } from '../models/PatientFTTicketUpdateSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FtTicketsApi {
    /**
     * Get Ft Tickets For Patient
     * Get patient FT ticket list, <br>Required Permission: get_patient_ft_ticket_list
     * @returns PatientFTTicketListSchema OK
     * @throws ApiError
     */
    public static insuranceGetFtTicketsForPatientGet({
        patientId,
        issueDateTo,
        onlyAccepted = false,
    }: {
        patientId: string,
        issueDateTo?: (string | null),
        onlyAccepted?: boolean,
    }): CancelablePromise<Array<PatientFTTicketListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/ft-tickets/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            query: {
                'issue_date_to': issueDateTo,
                'only_accepted': onlyAccepted,
            },
        });
    }
    /**
     * Create Patient Ft Ticket
     * Create new patient FT ticket, <br>Required Permission: create_patient_ft_ticket
     * @returns PatientFTTicketDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreatePatientFtTicketPost({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: PatientFTTicketCreateSchema,
    }): CancelablePromise<PatientFTTicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/ft-tickets/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Patient Issued Ft Ticket
     * Create new patient FT ticket issued, <br>Required Permission: create_patient_issued_ft_ticket
     * @returns PatientFTTicketDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreatePatientIssuedFtTicketPost({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: PatientFTTicketCreateSchema,
    }): CancelablePromise<PatientFTTicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/ft-tickets/{patient_id}/issued/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upload Patient Ft Ticket Image
     * Upload patient FT ticket image, <br>Required Permission: upload_patient_ft_ticket_image
     * @returns void
     * @throws ApiError
     */
    public static insuranceUploadPatientFtTicketImagePost({
        ftTicketId,
        formData,
    }: {
        ftTicketId: string,
        formData: {
            image: Blob;
        },
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/ft-tickets/{ft_ticket_id}/upload-image/',
            path: {
                'ft_ticket_id': ftTicketId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get Patient Ft Ticket Detail
     * Get patient FT ticket detail, <br>Required Permission: get_patient_ft_ticket_detail
     * @returns PatientFTTicketDetailSchema OK
     * @throws ApiError
     */
    public static insuranceGetPatientFtTicketDetailGet({
        patientId,
        ftTicketId,
    }: {
        patientId: string,
        ftTicketId: string,
    }): CancelablePromise<PatientFTTicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/ft-tickets/{patient_id}/{ft_ticket_id}/',
            path: {
                'patient_id': patientId,
                'ft_ticket_id': ftTicketId,
            },
        });
    }
    /**
     * Update Patient Ft Ticket
     * Update patient FT ticket, <br>Required Permission: update_patient_ft_ticket
     * @returns PatientFTTicketDetailSchema OK
     * @throws ApiError
     */
    public static insuranceUpdatePatientFtTicketPut({
        patientId,
        ftTicketId,
        requestBody,
    }: {
        patientId: string,
        ftTicketId: string,
        requestBody: PatientFTTicketUpdateSchema,
    }): CancelablePromise<PatientFTTicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/ft-tickets/{patient_id}/{ft_ticket_id}/',
            path: {
                'patient_id': patientId,
                'ft_ticket_id': ftTicketId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Patient Ft Ticket
     * Delete patient FT ticket. <br>Required Permission: remove_patient_ft_ticket
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeletePatientFtTicketDelete({
        patientId,
        ftTicketId,
    }: {
        patientId: string,
        ftTicketId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/ft-tickets/{patient_id}/{ft_ticket_id}/',
            path: {
                'patient_id': patientId,
                'ft_ticket_id': ftTicketId,
            },
        });
    }
}
